import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Sidebar from "../../../components/Layout/Sidebar";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import FormSkeleton from "../../components/skeleton/FormSkeleton";

import { Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";

import { getData as getVenue } from "../../../services/admin/defaultSetup/esVenueServices";

import {
  getData,
  addData,
  updateData,
  deleteData,
} from "../../../services/admin/defaultSetup/hotelSetupServices";
import { getSelectStyles } from "../../../utils/helper";

function HotelSetup() {
  const [dataList, setDataList] = useState([]);
  const [venue, setVenue] = useState([]);
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.data;
  const type = location.state?.type || "add";

  const returnUrl = "/hotelSetupList";

  const [form, setForm] = useState({
    id: "",
    venue: "",
    hotel_name: "",
    hall_names: [""],
  });



   const fetchData = useCallback(async () => {
      try {
        const data = await getData();
        setDataList(data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    }, []);

    useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true);
      await fetchData();
      // Optional 1 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };

    fetchDataAsync();
  }, [fetchData]);

  useEffect(() => {
    if (type === "edit" && editData) {
      setForm({
        id: editData.id,
        venue: editData.venue.trim() || "",
        hotel_name: editData.hotel_name || "",
        hall_names: editData.hall_names.split(",") || "",
      });
      setLoading(false);
    }
  }, [type, editData]);

  useEffect(() => {
    const fetchVenue = async () => {
      try {
        const data = await getVenue();
        setVenue(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchVenue();
  }, []);

  const venueOptions = venue?.map((item) => ({
    value: item.venue,
    label: item.venue,
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.venue) {
      newErrors.venue = "Venue is required";
    }     
    if (!form.hotel_name) newErrors.hotel_name = "Hotel Name is required";

    if (form.hall_names.some((hall) => !hall.trim())) {
      newErrors.hall_names = "Hall names are required";
    }
    

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);

    try {
      const payload = {
        ...form,
        hall_names: Array.isArray(form.hall_names)
          ? form.hall_names.join(", ")
          : form.hall_names,
      };
      if (type === "add") {
        await addData(payload);
      } else {
        await updateData(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: `Hotel Setup ${
          type === "add" ? "added" : "updated"
        } successfully`,
        timer: 2000,
        showConfirmButton: false,
      });

      navigate(returnUrl); // go back to list
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
      });
    } finally {
      setBtnLoading(false);
    }
  };

  const handleHallChange = (index, value) => {
    const updatedhall_names = [...form.hall_names];
    updatedhall_names[index] = value;

    setForm({
      ...form,
      hall_names: updatedhall_names,
    });
  };

  const addHall = () => {
    setForm({
      ...form,
      hall_names: [...form.hall_names, ""],
    });
  };

  const removeHall = (index) => {
    const updatedhall_names = form.hall_names.filter((_, i) => i !== index);

    setForm({
      ...form,
      hall_names: updatedhall_names.length ? updatedhall_names : [""],
    });
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <>
            <FormSkeleton />
          </>
        ) : (
          <>
            <div className="container-fluid p-4">
              <div className="row">
                <div className="col-8">      
                      <p className='fs-4 text-dark'> General Configuration / Default Setup / Hotel Setup </p>

                </div>

                <div className="col-4 text-end">
                  <button
                    className="btn btn-secondary mb-3"
                    onClick={() => navigate("/hotelSetupList")}
                  >
                    Back
                  </button>
                </div>
              </div>

              <div className="card p-4 mt-3">
                <Form>
                  <div className="row">
                    <Form.Group className="col-md-6 mb-3">
                      <Form.Label className="fs-5 text-dark">
                        Venue <span className="text-danger">*</span>
                      </Form.Label>

                      <Select
                        name="venue"
                        value={venueOptions.find(
                          (opt) => opt.value === form.venue.trim(),
                        )}
                        placeholder="Select a Venue"
                        onChange={(selectedOption) =>
                          handleChange({
                            target: {
                              name: "venue",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        options={venueOptions}
                        styles={getSelectStyles(errors.venue)}
                        // className={errors.venue ? "is-invalid" : ""}
                      />

                      {errors.venue && (
                        <div className="invalid-feedback d-block">
                          {errors.venue}
                        </div>
                      )}
                    </Form.Group>

                    {/* Hotel Name */}
                    <Form.Group className="col-md-6 mb-3">
                      <Form.Label className="fs-5 text-dark">
                        Hotel Name <span className="text-danger">*</span>
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="hotel_name"
                        value={form.hotel_name}
                        onChange={handleChange}
                        isInvalid={!!errors.hotel_name}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.hotel_name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    
                    <Form.Group className="col-md-12 mb-3">
                      <Form.Label className="fs-5 text-dark">
                        Hall Names <span className="text-danger">*</span>
                      </Form.Label>

                      {form?.hall_names?.map((hall, index) => (
                        <div key={index} className="d-flex mb-2 gap-2">
                          <Form.Control
                            type="text"
                            value={hall}
                            isInvalid={!!errors?.hall_names && !hall?.trim()}
                            onChange={(e) =>
                              handleHallChange(index, e.target.value)
                            }
                            placeholder={`Hall ${index + 1}`}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.hall_names}
                          </Form.Control.Feedback>

                          {form.hall_names.length > 1 && (
                            <Button
                              variant="danger"
                              onClick={() => removeHall(index)}
                            >
                              Remove
                            </Button>
                          )}
                        </div>
                      ))}

                      <Button variant="primary" onClick={addHall}>
                        + Add Hall
                      </Button>
                    </Form.Group>
                  </div>

                  {/* Buttons */}
                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => navigate(returnUrl)}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={btnLoading}
                    >
                      {btnLoading
                        ? type === "add"
                          ? "Adding..."
                          : "Updating..."
                        : type === "add"
                        ? "Add"
                        : "Update"}
                    </button>
                  </div>
                </Form>
              </div>
            </div>
            <Footer />
          </>
        )}
      </div>
    </div>
  );
}

export default HotelSetup;
